/**
 * Powrót z płatności online do strefy klienta: przed przejściem do ING Pay strefa zapamiętuje swój adres w tej karcie
 * przeglądarki (sessionStorage — nie trafia do bramki ani do adresu powrotu), a strona płatności pokazuje „Wróć do strefy”.
 */
const KEY = 'platnosc-powrot-strefa';
const MAX_AGE_MS = 6 * 3600_000;

export function rememberPortalReturn() {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ path: window.location.pathname, at: Date.now() }));
  } catch {
    /* tryb prywatny / zablokowane — bez przycisku powrotu */
  }
}

export function portalReturnPath(): string | null {
  try {
    const v = JSON.parse(sessionStorage.getItem(KEY) ?? 'null') as { path?: string; at?: number } | null;
    if (!v?.path || !v.path.startsWith('/strefa/') || !v.at || Date.now() - v.at > MAX_AGE_MS) return null;
    return v.path;
  } catch {
    return null;
  }
}
